export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_TOURNEE_MODELE = 'SET_TOURNEE_MODELE';
export const SET_TOURNEE_LAST_PAYLOAD = 'SET_TOURNEE_LAST_PAYLOAD';
export const SET_CRITERE = 'SET_CRITERE';
export const SET_MESSAGE_INFO = 'SET_MESSAGE_INFO';
